module.exports = __webpack_public_path__ + "media/newstyle/images/icon-facebook-purple-bbac365e10db7db9403e857c6fd58f24.svg";